import { render, staticRenderFns } from "./TabsColor.vue?vue&type=template&id=da135768&"
import script from "./TabsColor.vue?vue&type=script&lang=js&"
export * from "./TabsColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports